var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatChannelsi = function SvgChatChannelsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Group 5886"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Union 29"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.835 19.589a9 9 0 1 1 3.259-3.66L20.998 21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.997 19.4c1.416 0 2.79-.401 3.976-1.16l.648-.414.728.247 1.599.542-.43-2.406-.09-.514.228-.469a7.3 7.3 0 0 0 .742-3.23c0-4.078-3.32-7.396-7.401-7.396-4.08 0-7.399 3.318-7.399 7.396 0 4.082 3.32 7.404 7.399 7.404m9.001 1.6-4.163-1.411a8.954 8.954 0 0 1-4.838 1.41c-4.97 0-8.999-4.031-8.999-9.003C2.998 7.025 7.028 3 11.997 3s9.001 4.025 9.001 8.996c0 1.41-.324 2.744-.904 3.932L20.998 21z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M8.784 10.07h6.43",
    "data-name": "Line 96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M8.785 13.928h5.144",
    "data-name": "Line 97"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatChannelsi);
export default ForwardRef;